import React from 'react';
import {QuestionReport} from '../../../../../incase-domain/analytics';
import ReportAnswerPercentage from '../../../../../incase-domain/components/report/answer/ReportAnswerPercentage';
import {getAnswerStatus} from './utils';
import {IQuestionElements} from '../../../../../incase-domain/elements/question';

interface IQuestionReportElementProps {
    element: IQuestionElements;
    questionReport?: QuestionReport;
}

function QuestionReportComponent({element, questionReport}: IQuestionReportElementProps): JSX.Element {
    return (
        <>
            <div className="c-questionReport__answers">
                {questionReport?.answers?.map((answer, index) => (
                    <div className="c-questionReport__answers-item" key={index}>
                        <ReportAnswerPercentage
                            key={index}
                            label={answer.answerText}
                            percentage={answer.percentage}
                            type={getAnswerStatus(element, answer.answerText)}
                            showCorrect
                            isPresenter
                        />
                    </div>
                ))}
            </div>
        </>
    );
}

export default QuestionReportComponent;
